module.exports = __webpack_public_path__ + "img/japanese-“vacancy”-button.4b0a5fb0.png";